import axios from 'axios';
import { BASIC_KEY, HOST_CLOUD, TYPE_TOKEN } from 'constant';
import tokenService from 'services/auth.service';
import { locale } from 'devextreme/localization';
import listLang from '../utils/language.json';
import { router } from 'constant/router';

const getLangCode = () =>
  listLang?.list?.filter(o => o?.value === locale())?.[0]?.code || 'en-En';

const axiosClient = axios.create({
  baseURL: `${HOST_CLOUD}`,
  headers: {
    Authorization: BASIC_KEY,
  },
});

axiosClient.interceptors.request.use(
  config => {
    const token = tokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = `${TYPE_TOKEN} ${token}`;
    }
    return config;
  },
  error => {
    return Promise.resolve({
      status: '500',
      message: 'Server error',
      data: null,
      error: 'Client Server error',
    });
  },
);

axiosClient.interceptors.response.use(
  res => {
    return res;
  },
  async error => {
    const originalConfig = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalConfig?.url?.includes('oauth/token')
    ) {
      //Logout
      tokenService.removeToken();
      sessionStorage.clear();
      window.location.href = router.login;
    }
    return Promise.resolve({
      status: `${error?.response?.status}`,
      message: error?.response?.data?.error_description,
      data: null,
      error: error?.response?.data || null,
    });
  },
);

export { axiosClient };
